import React, { useEffect, useState } from "react";
import { supabase } from "../supabase";
import GoToTop from "../GoToTop";

function Publications() {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchpublications();
  }, []);

  const fetchpublications = async () => {
    try {
      const { data, error } = await supabase
        .from("publications")
        .select("id, book, category,author, url")
        .order("category", { ascending: true });

      if (error) throw error;

      setPublications(data || []);
    } catch (err) {
      console.error("Error fetching publications:", err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <GoToTop />
      <section id="portfolio" className="portfolio section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Publications</h2>
          <p>Books published by Karbi Lammet Amei</p>
        </div>

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <p>
            Since its inception, Karbi Lammet Amei dedicated continuously for
            the development and upliftment of Karbi language and literature as a
            whole. Thus, to preserve and protect the language there are various
            numbers of books published by them. Below given are the names of
            some books published that have been classified into different
            genres:
          </p>

          <table className="table table-striped">
            <thead>
              <tr>
                <th>Sl No.</th>
                <th>Name of the book</th>
                <th>Writer/Editor</th>
                <th>Category</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                 <tr>
                  <td colSpan={5} className="text-center text-danger">
                   Loading...
                  </td>
                </tr>
              
              ) : publications.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-danger">
                    No Publications Found
                  </td>
                </tr>
              ) : (
                <>
                  {publications.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.book}</td>
                      <td>{item.author}</td>
                      <td><span className="badge text-light bg-secondary" style={{paddingBottom:'6px'}}>{item.category}</span></td>
                      <td>
                        {item.url ? (
                          <a href={item.url} target="_blank">
                            Download
                          </a>
                        ):(<small style={{color:'grey'}}>Not Available</small>)}
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

export default Publications;
